import {defineStore} from "pinia";
import {setLocalStorageItem} from "@/helper.js";

export const useUser = defineStore('user', {
    state: () => {
        return {
            usersOnline: null,
            onlineChannel: null,
            theme: 'dark',
        }
    },
    getters: {
        // Either source saying "online" is enough - not presence-only. A reseller/bot account's
        // last_active is kept fresh by a scheduled job with no real browser session ever
        // attached, so requiring presence membership left it permanently stuck "Offline" no
        // matter how recent its DB status was. Accepted tradeoff: a real user's badge can stay
        // "Online" for a moment after they actually disconnect, until a fresh page load or
        // last_active going stale updates `status` too - see CLAUDE.md's "Realtime presence"
        // section.
        getUserStatusByIdOrStatus: (state) => {
            return (id, status) => {
                return Boolean(state.usersOnline?.[id]) || status;
            }
        },
    },
    actions: {
        toggleTheme() {
            if (typeof document !== 'undefined') document.body.classList.remove(this.theme);
            this.theme = this.theme === 'dark' ? 'light' : 'dark';
            if (typeof document !== 'undefined') document.body.classList.add(this.theme);
            setLocalStorageItem('color-scheme', this.theme);
        }
    }
})
